//완성본

import { t } from 'i18next';
import { ReactComponent as FilterIcon } from '../../icons/filter.svg';
import { ReactComponent as PlaceIcon } from '../../icons/place.svg';
import { openNewTab } from '../../utils/UIUtils';
import { useColorMode } from '@chakra-ui/react';
// import { useState } from 'react';

export interface IMenuItem {
  id: string;
  name: string;
  iconName?: string;
}

interface IOfflineLocationMenuProps {
  selectedMemberIds: string[];
  selectedMenuItemIds: string[];
  menuItems?: Array<IMenuItem>;
  onRequestNativeGeoLocation?: () => void;
  onItemClick?: (itemId: string) => void;
  isFilterButtonActive: boolean; // 이미 있다면 OK
  setIsFilterButtonActive: (active: boolean) => void; // 이 줄 추가!
}

const SITE_TYPE_MENU_SCROLL_ITEMS = [
  {
    id: 'likeLocation',
    name: t('SiteTypes.likeLocation'),
    iconName: '3D.like'
  },
  {
    id: 'birthday_cafe',
    name: t('SiteTypes.birthdayCafe'),
    iconName: '3D.Birthday cake'
  },
  {
    id: 'foodie_spot',
    name: t('SiteTypes.foodieSpot'),
    iconName: '3D.Restaurant'
  },
  {
    id: 'billboard_ad',
    name: t('SiteTypes.billboardAd'),
    iconName: '3D.Signboard'
  },
  { id: 'experience_space', name: t('SiteTypes.experienceSpace'), iconName: '3D.Exhibition' },
  { id: 'filming_location', name: t('SiteTypes.filmingLocation'), iconName: '3D.clapper_board' },
  { id: 'landmark', name: `${t('SiteTypes.landmark')}`, iconName: '3D.Place' }
];

const OfflineLocationMenu: React.FC<IOfflineLocationMenuProps> = ({
  selectedMenuItemIds,
  menuItems = SITE_TYPE_MENU_SCROLL_ITEMS,
  onRequestNativeGeoLocation,
  onItemClick,
  isFilterButtonActive,
  setIsFilterButtonActive
}) => {
  const { colorMode } = useColorMode();

  const handleItemClick = (item: IMenuItem) => {
    if (item.id === 'likeLocation') {
      return openNewTab('/locations/like');
    }
    if (item.id === 'filter') {
      setIsFilterButtonActive(true);
      onItemClick?.(item.id);
    } else {
      setIsFilterButtonActive(false);
      onItemClick?.(item.id);
    }
  };

  return (
    <div className="w-full overflow-x-auto hidden-scroll z-50 py-[4px]">
      <div className="flex flex-nowrap gap-[4px] pl-[24px]">
        <div
          className="w-[30px] h-[30px] p-[7px] self-center rounded-full bg-[rgba(0,0,0,0.65)] dark:bg-[rgba(255,255,255,0.45)]"
          onClick={onRequestNativeGeoLocation}
        >
          <PlaceIcon className="fill-pure-white" width={16} height={16} />
        </div>
        <MenuButton
          key="filter"
          item={{ id: 'filter', name: t('SiteTypes.filter') }}
          isSelected={isFilterButtonActive}
          colorMode={colorMode}
          onClick={handleItemClick}
        />
        {menuItems?.map((item) => (
          <MenuButton
            key={item.id}
            item={item}
            isSelected={selectedMenuItemIds.includes(item.id)}
            colorMode={colorMode}
            onClick={handleItemClick}
          />
        ))}
      </div>
    </div>
  );
};

export default OfflineLocationMenu;

interface IMenuButtonProps {
  item: IMenuItem;
  isSelected: boolean;
  colorMode: 'light' | 'dark';
  onClick: (item: IMenuItem) => void;
}

const MenuButton: React.FC<IMenuButtonProps> = ({ item, isSelected, colorMode, onClick }) => {
  // 이제 colorMode를 사용할 수 있습니다! onClick }) => {
  let buttonClass = '';
  if (item.id === 'filter') {
    if (isSelected) {
      buttonClass =
        colorMode === 'dark'
          ? 'text-[#8870FF] border border-solid border-[#8870FF] bg-black'
          : 'text-[#5C3DFA] border border-solid border-[#5C3DFA] bg-white';
    } else {
      buttonClass =
        colorMode === 'dark'
          ? 'text-[#CFCFD0] border border-solid border-[#303030] bg-black'
          : 'text-main-light-1 border border-solid border-separator-1 bg-white';
    }
  } else {
    buttonClass = isSelected
      ? 'text-primary-light dark:text-primary-dark border border-solid border-primary-light dark:border-primary-dark shadow-[0px_0px_4px_0px_rgba(92,61,250,0.49)] bg-white dark:bg-black'
      : 'text-main-light-2 dark:text-main-dark-2 border border-solid border-separator-1 dark:border-separator-dark-1 bg-white dark:bg-black';
  }
  return (
    <button
      type="button"
      id={`menuButton_${item.id}`}
      className={`relative flex-shrink-0 flex flex-row px-[12px] py-[6px] gap-[4px] z-10 text-[13px] leading-[16px] font-semibold rounded-full items-center ${buttonClass}`}
      onClick={() => onClick(item)}
    >
      {item.id === 'filter' ? (
        <FilterIcon
          className={
            isSelected
              ? colorMode === 'dark'
                ? 'fill-[#8870FF]'
                : 'fill-[#5C3DFA]'
              : colorMode === 'dark'
                ? 'fill-[#CFCFD0]'
                : 'fill-main-light-1'
          }
          style={{ width: '14px', height: '14px' }}
        />
      ) : (
        item.iconName && (
          <img
            className="w-[13px] h-[13px]"
            src={`/assets/icons/graphic-3d/${item.iconName}.png`}
            alt={item.name}
          />
        )
      )}
      {item.name}
    </button>
  );
};

